export enum Environments {
    Development = 'development',
    Production = 'production',
    Localhost = 'localhost'
}